export { LoaderService, LoaderEnabled } from 'sce-core';
// #TODO-LIBRARY update refrences



// WEBPACK FOOTER //
// /var/lib/jenkins/workspace/1_SCE_CI_CD_SIT/src/app/shared/components/loader/loader.service.ts